var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('p',{staticStyle:{"margin":"0","padding":"11px"}},[_vm._v("©2019 琉球大学島嶼地域科学研究所")])])}]

export { render, staticRenderFns }